<template>
  <div id="sidebar-img">
    <img src="@/assets/logo.png" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
#sidebar-img {
  text-align: center;

  img {
    // max-width: 300px;
    max-width: 16vw;
    height: auto;
  }
}
</style>
